import { render, staticRenderFns } from "./SeriesListingContainer.vue?vue&type=template&id=6c19231d"
import script from "./SeriesListingContainer.vue?vue&type=script&lang=js"
export * from "./SeriesListingContainer.vue?vue&type=script&lang=js"
import style0 from "./SeriesListingContainer.vue?vue&type=style&index=0&id=6c19231d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports